import { TriangleAlert, Wrench } from "lucide-react"
import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"
import type { CarReportKind } from "@/reducers/messagesSlice"

const CarReportBadge = ({ kind }: { kind: CarReportKind }) => {
  const { t } = useTranslation()
  const Icon = kind === "collision" ? TriangleAlert : Wrench

  return (
    <div
      data-testid={`car-report-${kind}`}
      className={cn(
        "mb-1 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold",
        kind === "collision"
          ? "bg-red-600 text-white"
          : "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100",
      )}
    >
      <Icon className="size-3.5" />
      {t(`chat.carReport.${kind}`)}
    </div>
  )
}

export default CarReportBadge
